exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-trash{margin-left:.55rem;margin-right:2.5rem;height:20px;cursor:pointer}", ""]);

// exports
